import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3 } from './roche-generic-link2.js';
import { d as defineCustomElement$2 } from './roche-icon2.js';

const rocheTableCss = ".table{display:flex;flex-wrap:wrap;padding:0;border-bottom:0.0625rem solid #bababa}.table .flex-inline{display:inline-flex}.table .mr5{margin-right:0.3125rem}.table .header-switch{margin:0.5rem 0 0 0.625rem;fill:#06c}.table .header-mobile{width:50%;display:flex;font-weight:400;font-size:0.8125rem;color:#ccc;padding-top:0.9375rem;border-bottom:0.0625rem solid #bababa}.table .header-desktop{padding:0.75rem 0;display:inline-flex;margin-top:1rem;color:#06c;font-size:1rem;font-weight:800;font-family:\"roche-sans\";cursor:pointer}.table .hide-small{width:0;display:none}.table .icon-blue{fill:#06c}.table .icon-red{fill:#9f3522}.table .col{box-sizing:border-box;overflow:hidden;flex-grow:1;width:100%;padding:0.75rem 0;list-style:none}.table .col-icon{width:5%;align-self:flex-end;padding-bottom:0.625rem}.table .black-triangle{display:inline-flex;position:relative;top:-4px}@media (min-width: 48rem){.table{border-bottom:none}.table .header-mobile{width:0;display:none}.table .hide-small{width:100%;display:flex;cursor:default}.table .col{width:50%}.table .mobile{display:none}.table .desktop{display:flex}}.table-width>.col{width:20%}.border-bottom{border-bottom:0.0625rem solid #bababa}.alphabet{margin:0;font-size:1.875rem;font-weight:200;font-style:italic;color:#666;padding:0.9375rem 0;font-family:\"roche-serif\", serif;border-bottom:0.125rem solid #bababa}.list-item{font-size:0.9375rem;font-weight:400;color:#333;font-family:\"roche-sans\", serif}.list-item.bold{font-weight:800}";
const RocheTableStyle0 = rocheTableCss;

const RocheTable$1 = /*@__PURE__*/ proxyCustomElement(class RocheTable extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.sortByTitle = createEvent(this, "sortByTitle", 7);
        this.headerCol1 = undefined;
        this.headerCol2 = undefined;
        this.headerCol3 = undefined;
        this.headerCol4 = undefined;
        this.trainingMaterialUrl = undefined;
        this.reverse = false;
        this.arrayData = [];
    }
    // eslint-disable-next-line class-methods-use-this
    sortByTitleHandler() {
        this.reverse = !this.reverse;
    }
    arrayDataWatcher(newValue) {
        if (typeof newValue === 'string') {
            this.arrayInput = JSON.parse(newValue);
        }
        else {
            this.arrayInput = newValue;
        }
    }
    componentWillLoad() {
        this.arrayDataWatcher(this.arrayData);
    }
    getSortedArray() {
        return this.arrayInput.sort((obj1, obj2) => {
            if (obj1.primaryName > obj2.primaryName) {
                return 1;
            }
            if (obj1.primaryName < obj2.primaryName) {
                return -1;
            }
            return 0;
        });
    }
    getKeys() {
        const sortedArray = this.getSortedArray();
        const reverseData = () => (this.reverse ? sortedArray.reverse() : sortedArray);
        return reverseData().reduce((r, e) => {
            const alphabet = e.primaryName[0];
            // eslint-disable-next-line no-param-reassign
            if (!r[alphabet])
                r[alphabet] = [e];
            else
                r[alphabet].push(e);
            return r;
        }, {});
    }
    render() {
        const entries = this.getKeys();
        return (h(Host, { key: '1a3292e1bf1b3b00c37e0fd2b9588fa0ddb9a7f0' }, h("section", { key: 'fde049af52a8d7cf91e3caec65afcbc6616d58ee', class: 'table table-width' }, h("div", { key: 'e00047d00d66e1424056dd1bcbd2fc800b069745', class: 'col header-desktop mr5', onClick: () => this.sortByTitleHandler() }, this.headerCol1, h("roche-icon", { key: '05cddd16e102d2461ef8e50aa5cc26e018559422', class: 'header-switch', width: '13px', icon: this.reverse ? 'mobile' : 'mobile' })), h("div", { key: '908b9b8f84186b44f54b297e1f743422cfb7c30a', class: 'col header-desktop hide-small mr5' }, this.headerCol2), h("div", { key: 'd3685b1e1ca31799ff169bef45d9ea48a5df1df4', class: 'col header-desktop hide-small mr5' }, this.headerCol3), h("div", { key: 'fd0a92442e90287134f277e607d34da31cc6d1de', class: 'col header-desktop hide-small' }, this.headerCol4), h("div", { key: '58940f0b3331ca4efd73b55897886f3bd9d32f12', class: 'col-icon' })), Object.keys(entries).map((key, i) => h("div", { id: key, key: i }, h("div", { class: 'alphabet' }, key), entries[key].map((item, k) => h("section", { class: 'table table-width', key: k }, h("div", { class: 'header-mobile' }, this.headerCol1), h("div", { class: 'col border-bottom' }, h("span", { class: 'list-item bold' }, item.primaryName), item.blackTriangle
            ? h("roche-icon", { class: 'black-triangle', height: '0.75rem', icon: 'mobile' })
            : '', h("div", { class: 'list-item' }, item.secondaryName)), h("div", { class: 'header-mobile' }, this.headerCol2), h("div", { class: 'col border-bottom' }, item.usageInformation
            ? item.usageInformation.map((list, n) => h("roche-generic-link", { key: n, icon: list.href.startsWith('https://') ? 'mobile' : 'mobile', style: { display: 'block' }, text: list.link, url: list.href ? list.href : '' }))
            : ''), h("div", { class: 'header-mobile' }, this.headerCol3), h("div", { class: 'col border-bottom' }, item.specialInformation
            ? item.specialInformation.map((list, n) => h("roche-generic-link", { key: n, icon: list.href.startsWith('https://') ? 'mobile' : 'mobile', style: { display: 'block' }, text: list.link, url: list.href ? list.href : '' }))
            : ''), h("div", { class: 'header-mobile' }, this.headerCol4), h("div", { class: 'col border-bottom' }, item.productInformation
            ? item.productInformation.map((list, n) => h("roche-generic-link", { key: n, icon: list.href.startsWith('https://') ? 'mobile' : 'mobile', style: { display: 'block' }, text: list.link, url: list.href ? list.href : '' }))
            : ''), h("div", { class: 'col-icon border-bottom' }, item.educationMaterial ? h("a", { href: `${this.trainingMaterialUrl}?produkt=${encodeURI(item.primaryName)}` }, h("roche-icon", { width: '24', height: '24', class: 'icon-blue flex-inline', icon: 'mobile' })) : '', item.redHandLetter && h("roche-icon", { width: '24', height: '24', class: 'icon-red flex-inline', icon: 'mobile' }))))))));
    }
    static get watchers() { return {
        "arrayData": ["arrayDataWatcher"]
    }; }
    static get style() { return RocheTableStyle0; }
}, [0, "roche-table", {
        "headerCol1": [1, "header-col-1"],
        "headerCol2": [1, "header-col-2"],
        "headerCol3": [1, "header-col-3"],
        "headerCol4": [1, "header-col-4"],
        "trainingMaterialUrl": [1, "training-material-url"],
        "arrayData": [1, "array-data"],
        "reverse": [32]
    }, [[0, "sortByTitle", "sortByTitleHandler"]], {
        "arrayData": ["arrayDataWatcher"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-table", "roche-generic-link", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-table":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheTable$1);
            }
            break;
        case "roche-generic-link":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheTable = RocheTable$1;
const defineCustomElement = defineCustomElement$1;

export { RocheTable, defineCustomElement };

//# sourceMappingURL=roche-table.js.map